import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tool-tip-usage',
  templateUrl: './tool-tip-usage.component.html',
  styleUrls: ['./tool-tip-usage.component.sass']
})
export class ToolTipUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
